const globalStyles = {
  body: {
    backgroundColor: "#121212",
  },
};

export default globalStyles;
